(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFilesEnableController',TabFilesEnableController);

    TabFilesEnableController.$inject = ['$uibModalInstance', 'entity', 'TabFiles'];

    function TabFilesEnableController($uibModalInstance, entity, TabFiles) {
        var vm = this;
        vm.tabFile = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmEnable = function () {
            vm.tabFile.isActive = true;
            TabFiles.enable(vm.tabFile,
                function () {
                    $uibModalInstance.close(true);
                },
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
